export const DBTables = {
    TEST_GROUP_DEV: "testGroupDev",
    TEST_GROUP_QA: "testGroup",
    TEST_GROUP_PROD: "testGroupProd",
}